
export default {
    name: 'RichContent',
    props: {
        blok: {
            type: Object,
            required: true
        }
    }
}
